import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import GlobalFooter from './GlobalFooter'

function PhoneSuccess() {
    const record = JSON.parse(localStorage.getItem("auth"))
    const navigate = useNavigate()
    const location = useLocation()
    const {result} = location.state || {}

    const currency_collected = record.data.cbInfo.currency_collected
    const currency_settled = record.data.cbInfo.currency_settled
    
    useEffect(()=>{
        if(!result) return
    },[])

    const handleClick = ()=>{
        if(currency_collected === "USD" && currency_settled==="USD"){
            return navigate('/pages/account-info')
        }else if((currency_collected === "EUR"|| currency_collected === "GBP") && (currency_settled==="EUR" || currency_settled==="GBP")){
            return navigate('/pages/payment-credential')
        }else if(currency_collected === "CAD" && currency_settled==="CAD"){
            return navigate('/pages/canada')
        }
        else{
            return navigate('/invalid')
        }
    }
  return (
    <div className='global_layout'>
        {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
            }
            */}
    
        <div className='global_container'>
            <div className='top_bar'>
                <img src='/images/global/arrow-left.svg' alt=''/>
                <img src='/images/global/close.svg' alt=''/>
            </div>

            <div className='global_content'>
                <img style={{width:"60px",height:"60px"}} src='/images/global/success.gif' alt='' />
                <p className='glob_title'>Successful!</p>
                <p className='glob_desc'>The phone number has been successfully verified.</p>
                
                <button className='btn' style={{marginTop:"18px",background:"#228985",borderRadius:"10000px"}} onClick={handleClick}>Ok, got it</button>

            </div>
        </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default PhoneSuccess